export function dateMillis(value: unknown): number | null {
  if (value == null || value === "") return null;
  try {
    let millis: number;
    if (value instanceof Date) millis = value.getTime();
    else if (typeof value === "string" || typeof value === "number")
      millis = new Date(value).getTime();
    else {
      const timestamp = value as {
        toMillis?: () => number;
        toDate?: () => Date;
        seconds?: number;
        _seconds?: number;
        nanoseconds?: number;
        _nanoseconds?: number;
      };
      if (typeof timestamp.toMillis === "function")
        millis = timestamp.toMillis();
      else if (typeof timestamp.toDate === "function")
        millis = timestamp.toDate().getTime();
      else {
        const seconds = timestamp.seconds ?? timestamp._seconds;
        if (typeof seconds !== "number") return null;
        millis =
          seconds * 1000 +
          (timestamp.nanoseconds ?? timestamp._nanoseconds ?? 0) / 1e6;
      }
    }
    return Number.isFinite(millis) ? millis : null;
  } catch {
    return null;
  }
}

export function formatUserDate(value: unknown): string {
  const millis = dateMillis(value);
  return millis === null
    ? "Not recorded"
    : new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/London",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
      }).format(millis);
}

export function isToday(value: unknown, now = Date.now()): boolean {
  const millis = dateMillis(value);
  const day = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  return millis !== null && day.format(millis) === day.format(now);
}

export function compareUserValues(
  a: unknown,
  b: unknown,
  key: string,
  direction: "asc" | "desc",
): number {
  const left = key === "createdAt" || key === "lastLoginAt" ? dateMillis(a) : a;
  const right =
    key === "createdAt" || key === "lastLoginAt" ? dateMillis(b) : b;
  // Missing data stays last in either direction.
  if (left == null && right == null) return 0;
  if (left == null) return 1;
  if (right == null) return -1;
  const diff =
    typeof left === "number" && typeof right === "number"
      ? left - right
      : Array.isArray(left) && Array.isArray(right)
        ? left.length - right.length
        : String(left).localeCompare(String(right), "en-GB", {
            sensitivity: "base",
            numeric: true,
          });
  return diff * (direction === "asc" ? 1 : -1);
}
